import { Trophy } from "lucide-react";
import { Link } from "react-router-dom";
import aqibImg from "@/assets/aqib.png";

const goals = [
  "Deliver premium digital solutions for global brands",
  "Enhance brand visibility and audience engagement",
  "Provide result-driven strategies for sustainable growth",
];

const AboutSection = () => {
  return (
    <section id="about" className="py-12 md:py-20 bg-surface-alt">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative flex justify-center order-2 lg:order-1">
            <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md">
              <div className="w-56 h-56 sm:w-72 sm:h-72 md:w-80 md:h-80 lg:w-96 lg:h-96 rounded-full gradient-hero mx-auto relative overflow-hidden">
                <img
                  src={aqibImg}
                  alt="Aqib Khan - Graphic Lines founder"
                  className="absolute bottom-0 left-1/2 -translate-x-1/2 w-48 sm:w-60 md:w-72 lg:w-80 z-10 object-contain"
                />
              </div>
              <div className="absolute bottom-6 left-0 sm:bottom-12 bg-card rounded-2xl shadow-xl px-4 py-3 md:px-5 md:py-4 animate-float z-20 flex items-center gap-2 md:gap-3">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-xl gradient-cta flex items-center justify-center">
                  <span className="text-primary-foreground font-bold text-xs md:text-sm">🏆</span>
                </div>
                <div>
                  <p className="text-xs md:text-sm font-display font-bold text-foreground">3+ Years</p>
                  <p className="text-[10px] md:text-xs text-muted-foreground">Experience</p>
                </div>
              </div>
              <div className="absolute top-4 right-0 sm:top-8 bg-card rounded-xl shadow-lg px-4 py-3 md:px-5 md:py-4 animate-float delay-200 z-20">
                <p className="text-2xl md:text-3xl font-display font-extrabold text-primary">73+</p>
                <p className="text-[10px] md:text-xs text-muted-foreground mt-1">Satisfied Clients</p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 text-center lg:text-left">
            <span className="text-xs font-semibold tracking-widest uppercase text-primary mb-3 block">
              About Graphic Lines
            </span>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-foreground mb-4 md:mb-6 leading-tight lg:text-5xl">
              About Graphic Lines
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-3 md:mb-4 text-sm md:text-base">
              Graphic Lines is a professional digital agency committed to helping businesses grow, scale, and shine in the digital world. Founded 3 years ago, we specialize in graphic designing, video editing, digital marketing, branding, ads management, and social media management.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4 md:mb-6 text-sm md:text-base">
              Our mission is to turn ideas into impactful visuals and strategies that connect with audiences worldwide. We believe in combining creative storytelling with data-driven strategies, ensuring every project delivers real results.
            </p>

            <h3 className="text-base md:text-lg font-bold text-foreground mb-3">Our Goals</h3>
            <ul className="space-y-2 mb-6 text-left mx-auto lg:mx-0 max-w-md">
              {goals.map((g) => (
                <li key={g} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Trophy className="w-4 h-4 text-primary flex-shrink-0" />
                  {g}
                </li>
              ))}
            </ul>

            <div className="flex gap-3 justify-center lg:justify-start flex-wrap">
              <Link
                to="/about"
                className="inline-flex px-6 py-3 md:px-8 rounded-full gradient-cta text-primary-foreground font-display font-semibold text-sm hover:opacity-90 transition-opacity"
              >
                About Us
              </Link>
              <a
                href="https://wa.me/+923058559591"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex px-6 py-3 rounded-full border-2 border-primary text-primary font-display font-semibold text-sm hover:bg-primary hover:text-primary-foreground transition-colors"
              >
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
